import { SearchParams } from '../searches/types';
import { ContractorItem } from '../types';
import { UpdateRequest } from '../../api/types';

/** TYPES **/
export const contractorsTypes = {
  SET_CONTRACTOR_TERRITORY: 'SET_CONTRACTOR_TERRITORY',
  SET_CONTRACTOR: 'SET_CONTRACTOR',
  FETCH_CONTRACTORS: 'FETCH_CONTRACTORS',
  FETCH_ALL_CONTRACTORS: 'FETCH_ALL_CONTRACTORS',
  CREATE_CONTRACTOR: 'CREATE_CONTRACTOR',
  UPDATE_CONTRACTOR: 'UPDATE_CONTRACTOR',
  DELETE_CONTRACTOR: 'DELETE_CONTRACTOR',
  SET_CONTRACTORS: 'SET_CONTRACTORS',
  SET_ALL_CONTRACTORS: 'SET_ALL_CONTRACTORS',
  ADD_CONTRACTOR: 'ADD_CONTRACTOR',
  PATCH_CONTRACTOR: 'PATCH_CONTRACTOR',
  ACTIVATE_CONTRACTOR: 'ACTIVATE_CONTRACTOR',
  DEACTIVATE_CONTRACTOR: 'DEACTIVATE_CONTRACTOR',
  DELETE_CONTRACTOR_TERRITORY: 'DELETE_CONTRACTOR_TERRITORY',
}

/** ACTIONS **/

export interface SetContractorTerritoryAction {
  type: typeof contractorsTypes.SET_CONTRACTOR_TERRITORY
  payload: { contractorId: string, territoryId: string }
  callback: (succ: boolean) => void
}

export interface DeleteContractorTerritoryAction {
  type: typeof contractorsTypes.DELETE_CONTRACTOR_TERRITORY
  payload: { contractorId: string, territoryId: string }
  callback: (succ: boolean) => void
}

export interface FetchContractorsAction {
  type: typeof contractorsTypes.FETCH_CONTRACTORS
  payload?: {
    page?: number
    size?: number
    searchParams?: Partial<SearchParams>
    institutional?: boolean | null
  }
  callback?: (succ: boolean) => void
}

export interface FetchAllContractorsAction {
  type: typeof contractorsTypes.FETCH_ALL_CONTRACTORS
  payload?: {
    page?: number
    size?: number
    searchParams?: Partial<SearchParams>
    institutional?: boolean | null
  }
  callback?: (succ: boolean) => void
}

export interface CreateContractorAction {
  type: typeof contractorsTypes.CREATE_CONTRACTOR
  payload: RequestPayload
  callback?: (succ: boolean, contractor?: ContractorItem) => void
}

export interface UpdateContractorAction {
  type: typeof contractorsTypes.UPDATE_CONTRACTOR
  payload: RequestPayload
  callback?: (succ: boolean) => void
}

export interface DeleteContractorAction {
  type: typeof contractorsTypes.DELETE_CONTRACTOR
  payload: RequestPayload
  callback?: (succ: boolean) => void
}

export interface SetContractorsAction {
  type: typeof contractorsTypes.SET_CONTRACTORS
  payload: ContractorsType
}

export interface SetAllContractorsAction {
  type: typeof contractorsTypes.SET_ALL_CONTRACTORS
  payload: ContractorItem[]
}

export interface AddContractorsAction {
  type: typeof contractorsTypes.ADD_CONTRACTOR
  payload: ContractorItem
}

export interface ActivateContractorAction {
  type: typeof contractorsTypes.ACTIVATE_CONTRACTOR
  payload: string
  callback: (succ: boolean) => void
}

export interface DeactivateContractorAction {
  type: typeof contractorsTypes.DEACTIVATE_CONTRACTOR
  payload: string
  callback: (succ: boolean) => void
}

export type ContractorsActions =
  | SetContractorTerritoryAction
  | FetchContractorsAction
  | FetchAllContractorsAction
  | CreateContractorAction
  | UpdateContractorAction
  | DeleteContractorAction
  | SetContractorsAction
  | AddContractorsAction
  | SetAllContractorsAction
  | ActivateContractorAction
  | DeactivateContractorAction

/** REDUCER **/

export interface RequestPayload {
  contractor: Partial<ContractorItem>
  page?: number
  size?: number
  institutional?: boolean
  updateRequest?: UpdateRequest
}

export interface ContractorsType {
  contractor: ContractorItem | null
  allItems: ContractorItem[]
  items: ContractorItem[]
  limit: number
  start: number
  total: number
}

// export interface ContractorType {
//   allItems: ContractorItem[]
//   items: ContractorItem[]
//   limit?: string
//   start?: string
//   total: string
// }

export interface RequestPayload {
  contractor: Partial<ContractorItem>
  page?: number
  size?: number
  institutional?: boolean
}
